import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { UtilService } from './../share/util/util.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SKS_MASTER_API_ENDPOINT, SMILE9_API_ENDPOINT, SMILE9_STATUS_API_ENDPOINT, MAINTENANCE_URL } from '../../environments/environment';
import { AuthenticateService } from '../share/authenticate/authenticate.service';
import { NavbarIf } from './navbar-if';
import { Router, RouterState } from '@angular/router';
import { SentryObserve } from '../share/sentry/sentry-observe';
import { SentryInit } from '../share/sentry/sentry-init';
declare var $;

@Injectable()
export class NavbarService {
  public noticeImgSrc = '../../assets/images/icon_bell_gray.png';
  public noticeImgSrcSubject = new Subject<string>();
  /** 通知リスト */
  public noticeList: NavbarIf.Notice[] = [];
  public noticeListSubject = new Subject<NavbarIf.Notice[]>();
  /** 通知未読数 */
  public notReadCount = 0;
  public notReadCountSubject = new Subject<number>();
  controlerName = 'api/Notice';
  /** ブラウザが保持するAngularのバージョン */
  currentVer: string = null;
  /** 通知ベルのアニメーション開始フラグ */
  public swingOnce = false;
  public swingOnceSubject = new Subject<boolean>();
  /** 予約カレンダーで予約未確定状態時のサインアウトボタン押下処理を管理する */
  public rsvCalendarCheckAbandonedSubject = new BehaviorSubject<string>(null);

  constructor(
    public http: HttpClient,
    public utilServ: UtilService,
    public authServ: AuthenticateService,
    public router: Router,
  ) { }

  /** 通常のサインアウト処理を実行した */
  public normalSignOut(): void {
    const isSignOutOk = this.checkIndiRsvCalendarSignOut();
    if (!isSignOutOk) return;

    this.authServ.signOut();
  }

  /** いただきます端末で個人予約画面のサインアウト処理を実行した */
  public itadakimasuSignOut(): void {
    const isSignOutOk = this.checkIndiRsvCalendarSignOut();
    if (!isSignOutOk) return;

    this.utilServ.uUI.cancelFullScreen();
    this.authServ.signOut();
  }

  /** 予約カレンダーの場合、予約未確定状態になっていないかチェックし、サインアウト可否を判定 */
  private checkIndiRsvCalendarSignOut(): boolean {
    if (location.pathname === '/individual/indi-rsv-calendar') {
      switch (this.rsvCalendarCheckAbandonedSubject.getValue()) {
        // 初回ボタン押下時
        case null:
          this.rsvCalendarCheckAbandonedSubject.next('check');
          return false;
        // サインアウトする選択をした
        case 'check-yes':
          this.rsvCalendarCheckAbandonedSubject.next(null);
          return true;
        // サインアウトしない選択をした
        case 'check-no':
          this.rsvCalendarCheckAbandonedSubject.next(null);
          return false;
        default:
          return false;
      }
    } else {
      return true;
    }
  }

  /** APIGatewayからアプリのステータス取得 */
  public async getAppStatus(): Promise<string> {
    const res: any = await this.http.request<any>('get', SMILE9_STATUS_API_ENDPOINT).toPromise();
    if (res) {
      switch (res.status) {
        // メンテナンス時はメンテページへ強制遷移
        case 'maintenance':
          const allowIpList: string[] = res.allowIpList.split(',').map(ip => ip.trim());
          if (allowIpList.some(ip => ip === res.sourceIp)) break;
          window.location.href = `${MAINTENANCE_URL}?prevurl=${location.href}`;
          break;
        default:
          // Angularのバージョン判定
          const isReloadOnAngularUpdate: string = sessionStorage.getItem('isReloadOnAngularUpdate');
          // APIが返すバージョンとAngularが保持するバージョンが違う場合はリロードする。
          if (this.currentVer !== res.currentAngularVersion && isReloadOnAngularUpdate !== res.currentAngularVersion) {
            // SessionStorageにバージョンを保持し、リロード後に意図せずリロードがループすることを防止する。
            sessionStorage.setItem('isReloadOnAngularUpdate', res.currentAngularVersion);
            this.authServ.isLoading = true;
            window.location.reload();
          }
          break;
      }

      SentryObserve.sentryObserveUsername = res.sentryObserveUsername;
      SentryInit.checkSentryInit();
    }
    return res;
  }

  /** 通知データを非同期取得
   * AppComponentでページ遷移直後に実行される
   */
  public async getNoticeAsync() {
    if (!this.authServ.token) {
      return;
    }

    this.getNoticeList()
    .subscribe(
      response => {
        let res = response as any;
        if (res) {
          // [アップデート通知を画面上からは非公開にしたい場合の為の処理] アップデート通知のbodyがnull or '' だった時は通知配列から除くことで非表示にする。マイナーアップデート時に活用する。
          res = res.filter(notice => !(notice.notice_type === 100 && ( notice.body === null || notice.body === '' )));
        }
        this.updateNoticeProps(res);
      }
    );
  }

  /** 通知データ取得 */
  public getNoticeList(): Observable<any> {
    return this.http.request('get', SMILE9_API_ENDPOINT + `${this.controlerName}/NoticeList`);
  }

  /** 通知データを非同期で既読にする */
  async readNoticeOnDisplayAsync() {
    if (this.noticeList.length === 0) {
      return;
    }
    const readNoticeIdList: {notice_id: number}[] = [];
    this.noticeList.forEach(notice => {
      if (notice.is_read === 0 && notice.notice_id !== 0) {
        readNoticeIdList.push({notice_id: notice.notice_id});
      }
    });
    // 全て既読ならば通信しない
    if (readNoticeIdList.length === 0) {
      return;
    }

    const httpBody: NavbarIf.ReadNoticeModel = {
      readNoticeIdList: readNoticeIdList
    };
    Object.assign(httpBody, this.utilServ.uTrans.returnBasicColumns());
    this.http.request('post', `${SKS_MASTER_API_ENDPOINT}${this.controlerName}/Read`, { body: httpBody }).subscribe(
      res => {
        this.getNoticeAsync();
      }
    );
  }

  /** 通知関連プロパティを更新 */
  private updateNoticeProps(res: any[]) {
    this.noticeList.length = 0;
    this.notReadCount = 0;
    if (res && res.length > 0) {
      res.forEach(record => {
        this.noticeList.push(record);
          // 未読件数カウント
          if (record.is_read === 0 ||
              record.is_read === 2 ||
              (record.notice_type === 100 && record.version > this.currentVer)) {
            this.notReadCount++;
          }
      });
    }
    this.notReadCountSubject.next(this.notReadCount);
    this.noticeListSubject.next(this.noticeList);

    // 画面のベルアイコンの切り替え
    if (this.notReadCount === 0) {
      this.noticeImgSrc = '../../assets/images/icon_bell_gray.png';
    } else {
      this.noticeImgSrc = '../../assets/images/icon_bell.png';
    }
    this.noticeImgSrcSubject.next(this.noticeImgSrc);
  }

  openNoticeModal(event: Event) {
    if (this.noticeList.length > 0) {
      $('#noticeModal').modal({backdrop: 'static'}, 'show');
    }
    event.stopPropagation();
  }
}
